export default "__VITE_ASSET__hBDNg4RECWblwnDO8Y9tbw__"